import Api from "../../../util/Api";

export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        rowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'seeRow'
            }
        ],
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            }
        ],
        searchFieldsFeuPartnerManager: [
            {
                name: "originalId",
                label: "Foglalás ID",
                formSize: 3,
                formType: "number"
            },
            {
                name: "operation",
                label: "Művelet",
                formSize: 3,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    externalOptionList: [
                        {id: 'INSERT', text: 'Létrehozás'},
                        {id: 'DELETE', text: 'Törlés'},
                        {id: 'UPDATE FROM', text: 'Módosítás (eredeti)'},
                        {id: 'UPDATE TO', text: 'Módosítás (új)'},
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
            },
            {
                name: "histCreatedFrom",
                label: "History készítésének dátuma (tól)",
                formSize: 3,
                formType: 'date'
            },
            {
                name: "histCreatedTo",
                label: "History készítésének dátuma (ig)",
                formSize: 3,
                formType: 'date'
            },
            {
                name: "patientName",
                label: "Páciens neve",
                formSize: 3,
                formType: 'text',
                formVisible: true,
            },
            {
                name: "appointmentTimeFrom",
                label: "Foglalás időponttól",
                formSize: 3,
                formType: 'date'
            },
            {
                name: "appointmentTimeTo",
                label: "Foglalás időpontig",
                formSize: 3,
                formType: 'date'
            },
            {
                label: "Technikai azonosító",
                name: "prefixedId",
                formType: "text",
                formSize: 3,
                formVisible: true,
            },
        ],
        searchFields: [
            {
                name: "originalId",
                label: "Foglalás ID",
                formSize: 3,
                formType: "number"
            },
            {
                name: "operation",
                label: "Művelet",
                formSize: 3,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    externalOptionList: [
                        {id: 'INSERT', text: 'Létrehozás'},
                        {id: 'DELETE', text: 'Törlés'},
                        {id: 'UPDATE FROM', text: 'Módosítás (eredeti)'},
                        {id: 'UPDATE TO', text: 'Módosítás (új)'},
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
            },
            {
                name: "histCreatedBy",
                label: "History készítője",
                formSize: 3,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllUserForSelect,
                    formatText: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    formatOption: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'lastName',
                    returnValue: 'username',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "histCreatedFrom",
                label: "History készítésének dátuma (tól)",
                formSize: 3,
                formType: 'date'
            },
            {
                name: "histCreatedTo",
                label: "History készítésének dátuma (ig)",
                formSize: 3,
                formType: 'date'
            },
            {
                name: "doctorId",
                label: "Orvos",
                formSize: 3,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllDoctor,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "patientName",
                label: "Páciens neve",
                formSize: 3,
                formType: 'text',
                formVisible: true,
            },
            {
                name: "patientEmail",
                label: "Páciens e-mail",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "signCode",
                label: "Szignó kód",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "appointmentExtId",
                label: "Foglalás külső ID",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "appointmentTimeFrom",
                label: "Foglalás időponttól",
                formSize: 3,
                formVisible: true,
                formType: 'date'
            },
            {
                name: "appointmentTimeTo",
                label: "Foglalás időpontig",
                formSize: 3,
                formVisible: true,
                formType: 'date'
            },
            {
                label: "Technikai azonosító",
                name: "prefixedId",
                formType: "text",
                formSize: 3,
                formVisible: true,
            },
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "createdBy",
                label: "Készítő",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "createdOn",
                label: "Készítés dátuma",
                slot_name: "created_on_format",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true,
                formType: "dateTime"
            },
            {
                name: "modifiedBy",
                label: "Módosító",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "modifiedOn",
                label: "Módosítás dátuma",
                slot_name: "modified_on_format",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true,
                formType: "dateTime"
            },
            {
                name: "originalId",
                label: "Foglalás ID",
                sort: false,
                visibility: true,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "operation",
                label: "Művelet",
                sort: true,
                slot_name: "operation_format",
                visibility: true,
                formType: 'select',
                selectOptions: {
                    externalOptionList: [
                        {id: 'INSERT', text: 'Létrehozás'},
                        {id: 'DELETE', text: 'Törlés'},
                        {id: 'UPDATE FROM', text: 'Módosítás (eredeti)'},
                        {id: 'UPDATE TO', text: 'Módosítás (új)'},
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "histCreatedBy",
                label: "History készítője",
                sort: true,
                visibility: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllUserForSelect,
                    formatText: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    formatOption: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'lastName',
                    returnValue: 'username',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "histCreatedOn",
                label: "History készítésének dátuma",
                slot_name: "hist_created_on_format",
                sort: true,
                visibility: true,
                formVisible: true,
                viewModalShow: true,
                formType: "dateTime"
            },
            {
                name: "appointment",
                label: "Foglalás",
                slot_name: "appointment_format",
                sort: true,
                visibility: true,
                formVisible: true,
                viewModalShow: true,
                formType: "dateTime"
            },
            {
                name: "appointmentDuration",
                label: "Foglalás hossza",
                sort: false,
                visibility: true,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "patientFullName",
                label: "Páciens neve",
                sort: false,
                visibility: true,
                formVisible: true,
                viewModalShow: true,
                slot_name: "patientNameFormat"
            },
            {
                name: "prefixedId",
                label: "Technikai azonosító",
                sort: false,
                visibility: true,
                viewModalShow: true,
                formVisible: true,
            },
            {
                name: "patientEmail",
                label: "Páciens e-mail",
                sort: false,
                visibility: false,
                formType: 'text',
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "patientAddress",
                label: "Páciens cím",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "patientPhone",
                label: "Páciens tel.",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "patientDateOfBirth",
                label: "Páciens születési dátuma",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "patientPlaceOfBirth",
                label: "Páciens születési helye",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "patientMotherName",
                label: "Páciens anyja neve",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "patientSocialInsuranceNumber",
                label: "Páciens TAJ",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "patientIdCardNumber",
                label: "Páciens szem. ig. száma",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "doctor.fullName",
                label: "Orvos",
                sort: false,
                visibility: true,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "signCode",
                label: "Szignó kód",
                sort: false,
                visibility: true,
                formType: 'text',
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "treatment.title",
                label: "Kezelés",
                sort: false,
                visibility: true,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "status",
                label: "Státusz",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "appointmentStatus.text",
                label: "Státusz",
                sort: false,
                visibility: true,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "outdoorAdminEmail",
                label: "Külső admin e-mail",
                sort: false,
                visibility: true,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "appointmentExtId",
                label: "Foglalás külső ID",
                sort: false,
                visibility: true,
                formType: 'text',
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "doctorId",
                label: "Orvos ID",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "contactType",
                label: "Kapcsolat",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "partner",
                label: "Partner",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "patientId",
                label: "Páciens ID",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "treatmentId",
                label: "Kezelés ID",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "contactId",
                label: "contactId",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "partnerId",
                label: "Partner ID",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "note",
                label: "Megjegyzés",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "roomId",
                label: "roomId",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "siteId",
                label: "Telephely ID",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "seen",
                label: "Megnézve?",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        headerFieldsFeuPartnerManager: [
            {
                name: "id",
                label: "ID",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "createdBy",
                label: "Készítő",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "createdOn",
                label: "Készítés dátuma",
                slot_name: "created_on_format",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true,
                formType: "dateTime"
            },
            {
                name: "modifiedBy",
                label: "Módosító",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "modifiedOn",
                label: "Módosítás dátuma",
                slot_name: "modified_on_format",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true,
                formType: "dateTime"
            },
            {
                name: "originalId",
                label: "Foglalás ID",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "operation",
                label: "Művelet",
                sort: true,
                slot_name: "operation_format",
                visibility: true,
                formType: 'select',
                selectOptions: {
                    externalOptionList: [
                        {id: 'INSERT', text: 'Létrehozás'},
                        {id: 'DELETE', text: 'Törlés'},
                        {id: 'UPDATE FROM', text: 'Módosítás (eredeti)'},
                        {id: 'UPDATE TO', text: 'Módosítás (új)'},
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "histCreatedBy",
                label: "History készítője",
                sort: true,
                visibility: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllUserForSelect,
                    formatText: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    formatOption: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'lastName',
                    returnValue: 'username',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "histCreatedOn",
                label: "History készítésének dátuma",
                slot_name: "hist_created_on_format",
                sort: true,
                visibility: true,
                formVisible: true,
                viewModalShow: true,
                formType: "dateTime"
            },
            {
                name: "appointment",
                label: "Foglalás",
                slot_name: "appointment_format",
                sort: true,
                visibility: true,
                formVisible: true,
                viewModalShow: true,
                formType: "dateTime"
            },
            {
                name: "appointmentDuration",
                label: "Foglalás hossza",
                sort: false,
                visibility: true,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "patientFullName",
                label: "Páciens neve",
                sort: false,
                visibility: true,
                formVisible: true,
                viewModalShow: true,
                slot_name: "patientNameFormat"
            },
            {
                name: "patient.prefixedId",
                label: "Technikai azonosító",
                sort: false,
                visibility: true,
                viewModalShow: true,
                formVisible: true,
            },
            {
                name: "patientEmail",
                label: "Páciens e-mail",
                sort: false,
                visibility: false,
                formType: 'text',
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "patientAddress",
                label: "Páciens cím",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "patientPhone",
                label: "Páciens tel.",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "doctor.fullName",
                label: "Orvos",
                sort: false,
                visibility: true,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "signCode",
                label: "Szignó kód",
                sort: false,
                visibility: true,
                formType: 'text',
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "treatment.title",
                label: "Kezelés",
                sort: false,
                visibility: true,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "status",
                label: "Státusz",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "appointmentStatus.text",
                label: "Státusz",
                sort: false,
                visibility: true,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "outdoorAdminEmail",
                label: "Külső admin e-mail",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "appointmentExtId",
                label: "Foglalás külső ID",
                sort: false,
                visibility: false,
                formType: 'text',
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "doctorId",
                label: "Orvos ID",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "contactType",
                label: "Kapcsolat",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "partner",
                label: "Partner",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "patientId",
                label: "Páciens ID",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "treatmentId",
                label: "Kezelés ID",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "contactId",
                label: "contactId",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "partnerId",
                label: "Partner ID",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "note",
                label: "Megjegyzés",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "roomId",
                label: "roomId",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "siteId",
                label: "Telephely ID",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "seen",
                label: "Megnézve?",
                sort: false,
                visibility: false,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
